import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["value", "name", "checked", "disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.willDisplay)
    ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: "switch",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickSwitcher && _ctx.clickSwitcher(...args)))
      }, [
        _createElementVNode("input", {
          type: "checkbox",
          value: _ctx.value,
          name: _ctx.getName,
          checked: _ctx.defaultChecked,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectCheckbox && _ctx.selectCheckbox(...args))),
          class: _normalizeClass(_ctx.defaultChecked),
          disabled: _ctx.disabled
        }, null, 10, _hoisted_1),
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
}